import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    addToWatchList,
    removeFromWatchList,
    addToReadList,
    removeFromReadList,
    resetSearch,
} from '../../modules/user';
import Grid from 'material-ui/Grid';
import Button from '../../components/Buttons';
import BookTile from '../../components/BookTile';
import Notification from '../../components/Notification';
import {
    currentLevelImage,
    currentLevelName
} from '../../helper/Helper';
import NoSearchResultsImgSrc from '../../assets/images/HomePage/no_search_result.png';
import './SearchResult.css';
import ReplayIcon from 'material-ui-icons/Replay';
import {
    scroller,
    Element,
} from 'react-scroll';

class SearchResult extends Component {
    static propTypes = {
        booklist: PropTypes.array.isRequired,
        watchList: PropTypes.array.isRequired,
        readList: PropTypes.array.isRequired,
        addToWatchList: PropTypes.func.isRequired,
        removeFromWatchList: PropTypes.func.isRequired,
        addToReadList: PropTypes.func.isRequired,
        removeFromReadList: PropTypes.func.isRequired,
        gradeName: PropTypes.string.isRequired,
        isInputSearch: PropTypes.bool.isRequired,
    };

    state = {
        currentFilter: this.props.isInputSearch? '' : 'title',
        numberResults: 20,
        isShowLoadMoreButton: true,
    };

    renderBookTiles = () => {
        const {
            removeFromWatchList,
            removeFromReadList
        } = this.props;
        const {
            currentFilter,
            numberResults
        } = this.state;

        let bookList = [ ...this.props.booklist ];

        function sort(array, parameter) {
            array.sort( (a, b) => {
                if(a[parameter] < b[parameter]) return -1;
                if(a[parameter] > b[parameter]) return 1;
                return 0;
            })
            return array
        }

        switch(currentFilter) {
            case 'title':
                bookList = sort(bookList, 'title');
                break;
            case 'author':
                bookList = sort(bookList, 'author');
                break;
            default:
                break;
        }

        return bookList.map((book, i) => {
            const isInWatchList = !!this.isInWatchList(book.bookId)
            const isInReadList = !!this.isInReadList(book.bookId)
            if (i >= numberResults) { // Only render specific number of results
                return null
            } else {
                return <BookTile
                    key={i}
                    book={book}
                    isInWatchList={isInWatchList}
                    isInReadList={isInReadList}
                    addToWatchList={this.addToWatchListHandler}
                    removeFromWatchList={removeFromWatchList}
                    addToReadList={this.addToReadListHandler}
                    removeFromReadList={removeFromReadList}
                />
            }
        });
    }

    addToReadListHandler = (book) => {
        if(this.props.isLoggedIn) {
            this.props.addToReadList(book)
        } else {
            window.location.href = '/prc/logon.html'
        }
    }

    addToWatchListHandler = (book) => {
        if(this.props.isLoggedIn) {
            this.props.addToWatchList(book)
        } else {
            window.location.href = '/prc/logon.html'
        }
    }

    isInWatchList = (bookId) => {
        return this.props.watchList.find(b => String(b.bookId) === String(bookId))
    }

    isInReadList = (bookId) => {
        return this.props.readList.find(b => String(b.bookId) === String(bookId))
    }

    // TODO: refactor the filter buttons code
    renderFilterButton = () => {
        return  <div className="searchResult__filter">
                    <span className="searchResult__filter--text">Sort by:</span>
                    <Button
                        aria-label="Sort by Title"
                        className="searchResult__filter--button"
                        onClick={() => {this.filterClickHandler('title')}}
                        color={this.state.currentFilter === 'title' ? 'primary' : 'secondary' }
                        size="small"
                        variant="raised">
                        Title
                    </Button>
                    <Button
                        aria-label="Sort by Author"
                        className="searchResult__filter--button"
                        onClick={() => {this.filterClickHandler('author')}}
                        color={this.state.currentFilter === 'author' ? 'primary' : 'secondary'}
                        size="small"
                        variant="raised">
                        Author
                    </Button>
                </div>
    }

    filterClickHandler = (filter) => {
        this.setState({currentFilter: filter});
    }

    newSearchClickHandler = (e) => {
        e.preventDefault();
        this.props.resetSearch();
        scroller.scrollTo('searchInput', {
            duration: 800,
            smooth: true,
        })
        document.getElementById('home_input_search').focus();
    }

    renderSearchResultInfo = (info, id) => {
        return  <div className="searchResult__info">
                    <span>{info}</span>
                    <a href="#/resetSearch"
                       id={id? id : null}
                       onClick={this.newSearchClickHandler}>New Search</a>
                </div>
    }

    loadMoreClickHandler = () => {
        const numberBooksNotRendered = this.props.booklist.length - this.state.numberResults;
        const numberAddToResults = numberBooksNotRendered < 20 ? numberBooksNotRendered : 20; // showing 20 books perload
        this.setState({
            numberResults: this.state.numberResults + numberAddToResults,
            // Hide the LoadMore button if all books listed
            isShowLoadMoreButton: numberBooksNotRendered < 20 ? false : true
        })
    }

    renderLoadMoreButton = () => {
        if (this.state.isShowLoadMoreButton) {
            return  <Button
                        color="secondary"
                        variant="raised"
                        onClick={ ()=> this.loadMoreClickHandler()}>
                        <ReplayIcon></ReplayIcon>
                        Load More
                    </Button>
        }
    }

    renderNoResultMessage = () => {
        return  <div className="searchResult__noResults">
                    <img src={NoSearchResultsImgSrc} width={130} height={46} alt="homepage_no_result"/>
                    <p>We looked all around but couldn't find any books.</p>
                    <p>Search again ?</p>
                </div>
    }

    renderResult = () => {
        const { booklist } = this.props;
        const { numberResults } = this.state;
        const pageBookNumber = numberResults > booklist.length? booklist.length : numberResults;
        return  <div>
                    {this.renderFilterButton()}
                    <Grid container
                          spacing={24}>
                        {this.renderBookTiles()}
                    </Grid>
                    <div className="searchResult__loadMore">
                        {booklist.length > 20 ? this.renderLoadMoreButton():''}
                    </div>
                    {this.renderSearchResultInfo(
                        `Showing ${pageBookNumber === 0 ? '0' : '1'} - ${pageBookNumber} of ${booklist.length} books`
                    )}
                </div>
    }

    render () {
        const {
            gradeName,
            booklist,
            readList,
            watchList
        } = this.props;
        const levelName = currentLevelName(readList.length, gradeName);
        return (
            <div>
                <Element name="searchResultAnchor"></Element>
                <hr/>
                <Notification
                    readBooksNum={readList.length}
                    markedBooksNum={watchList.length}
                    levelName={levelName}
                    levelImage={currentLevelImage(levelName, true)}
                    isHighGrade={parseInt(gradeName, 10) > 2}
                />
                {this.renderSearchResultInfo(`${booklist.length} books found`, 'newSearchLink')}
                {booklist.length === 0 ?  this.renderNoResultMessage() : this.renderResult()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return ({
        booklist: state.user.bookList,
        watchList: state.user.watchList,
        readList: state.user.readList,
        gradeName: get(state, 'student.studentDetails.gradeName'),
        isLoggedIn: !!get(state, 'student.studentDetails.studentId'),
    });
}

const mapDispatchToProps = dispatch => bindActionCreators({
    addToWatchList,
    removeFromWatchList,
    addToReadList,
    removeFromReadList,
    resetSearch,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SearchResult);
